import { render, staticRenderFns } from "./header-lang.vue?vue&type=template&id=1ba6a6b3&scoped=true&"
import script from "./header-lang.vue?vue&type=script&lang=js&"
export * from "./header-lang.vue?vue&type=script&lang=js&"
import style0 from "./header-lang.vue?vue&type=style&index=0&id=1ba6a6b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba6a6b3",
  null
  
)

export default component.exports